import store from '../../../core/store';
import { backendURL } from '../../../core/utils';
import { downloadFile } from '../general/downloader';

export const listWorkingSetPlans = (stage_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/LIST_WORKING_SET_PLANS',
    method: 'GET',
    endpoint: '/stages/' + stage_id + '/plans/working',
    main: true,
  });
};

export const optimizeStagePlanMemory = (stage_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/OPTIMIZE_STAGE_PLAN_MEMORY',
    method: 'POST',
    endpoint: '/stages/' + stage_id + '/plans/optimize_memory',
  });
};

export const retilePlanVersion = (plan_version_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/RETILE_PLAN_VERSION',
    method: 'POST',
    endpoint: '/plans/versions/' + plan_version_id + '/retile',
  });
};

export const readPlanVersion = (plan_version_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/READ_PLAN_VERSION',
    method: 'GET',
    endpoint: '/plans/versions/' + plan_version_id,
    has404: true,
    main: true,
  });
};

export const readWorkingSetPlan = (plan_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/READ_WORKING_SET_PLAN',
    method: 'GET',
    endpoint: '/plans/working/' + plan_id,
    has404: true,
  });
};

export const updateWorkingSetPlan = (plan_id, formData) => {
  return store.dispatch({
    action: 'table.working_set_plans/UPDATE_WORKING_SET_PLAN',
    method: 'PUT',
    endpoint: '/plans/working/' + plan_id,
    data: formData,
  });
};

export const deleteWorkingSetPlan = (plan_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/DELETE_WORKING_SET_PLAN',
    method: 'DELETE',
    endpoint: '/plans/working/' + plan_id,
  });
};

export const downloadPlanVersion = (plan_version_id) => {
  return downloadFile(
    backendURL + '/plans/versions/' + plan_version_id + '/download',
    [],
    'POST'
  );
};

export const exportPlanVersion = (plan_version_id, formData) => {
  return downloadFile(
    backendURL + '/plans/versions/' + plan_version_id + '/export',
    formData,
    'POST'
  );
};

export const uploadNewPlanVersion = (plan_id, file) => {
  return store.dispatch({
    action: 'table.working_set_plans/UPLOAD_NEW_PLAN_VERSION',
    method: 'POST',
    preloaded: false,
    endpoint: '/plans/' + plan_id + '/versions',
    progress: true,
    id: plan_id,
    data: {
      file,
    },
  });
};

export const removeNewPlanVersionUpload = (plan_id) => {
  return store.dispatch({
    type: 'table.working_set_plans/REMOVE_NEW_PLAN_VERSION_UPLOAD',
    plan_id,
  });
};

export const createDelivery = (team_id, formData) => {
  return store.dispatch({
    action: 'table.working_set_plans/CREATE_DELIVERY',
    method: 'post',
    endpoint: '/teams/' + team_id + '/deliveries',
    data: formData,
  });
};

export const addToExistingDelivery = (delivery_id, formData) => {
  return store.dispatch({
    action: 'table.working_set_plans/ADD_TO_EXISTING_DELIVERY',
    method: 'put',
    endpoint: '/deliveries/' + delivery_id + '/plans',
    data: formData,
  });
};

export const listExistingDeliveries = (team_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/LIST_EXISTING_DELIVERIES',
    method: 'GET',
    endpoint: '/teams/' + team_id + '/existing_deliveries',
  });
};

export const listDeliveryApprovers = (team_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/LIST_DELIVERY_APPROVERS',
    method: 'GET',
    endpoint: '/teams/' + team_id + '/delivery_approvers',
  });
};

export const uploadPlanFiles = (plan_id, files) => {
  return store.dispatch({
    action: 'table.working_set_plans/UPLOAD_PLAN_FILE',
    method: 'POST',
    preloaded: false,
    endpoint: '/plans/' + plan_id + '/files',
    data: {
      files,
    },
  });
};

export const deletePlanFile = (plan_id, attachment_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/DELETE_PLAN_FILE',
    method: 'DELETE',
    endpoint: '/plans/' + plan_id + '/files',
    data: {
      attachment_id,
    },
  });
};

export const deletePlanVersion = (plan_version_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/DELETE_PLAN_VERSION',
    method: 'DELETE',
    endpoint: '/plans/versions/' + plan_version_id,
  });
};

export const readPlanVersionAnotation = (plan_version_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/READ_PLAN_VERSION_ANNOTATION',
    method: 'GET',
    endpoint: '/plans/versions/' + plan_version_id + '/annotations',
    has404: true,
  });
};

export const updatePlanVersionAnotation = (plan_version_id, objects) => {
  return store.dispatch({
    action: 'table.working_set_plans/UPDATE_PLAN_VERSION_ANNOTATION',
    method: 'PUT',
    endpoint: '/demo/plans/versions/' + plan_version_id + '/annotations',
    data: { data: objects },
  });
};

export const listPlanVersionTasks = (plan_version_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/LIST_PLAN_VERSION_TASKS',
    method: 'GET',
    endpoint: '/plans/versions/' + plan_version_id + '/tasks',
  });
};

export const listPlanVersionPlans = (plan_version_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/LIST_PLAN_VERSION_PLANS',
    method: 'GET',
    endpoint: '/plans/versions/' + plan_version_id + '/plans',
  });
};

export const filterPlanVersionAnnotations = () => {
  return store.dispatch({
    type: 'table.working_set_plans/FILTER_PLAN_VERSION_ANNOTATIONS',
  });
};

export const listPossiblePlanVersionPlans = (plan_version_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/LIST_POSSIBLE_PLAN_VERSION_PLANS',
    method: 'GET',
    endpoint: '/plans/versions/' + plan_version_id + '/possible_plans',
  });
};

export const attachPlanToPlanVersion = (plan_version_id, formData) => {
  return store.dispatch({
    action: 'table.working_set_plans/ATTACH_PLAN_TO_PLAN_VERSION',
    method: 'POST',
    endpoint: '/plans/versions/' + plan_version_id + '/attach_plan',
    data: formData,
  });
};

export const listComparablePlanVersions = (plan_version_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/LIST_COMPARABLE_PLAN_VERSIONS',
    method: 'GET',
    endpoint: '/plan_versions/' + plan_version_id + '/compares',
  });
};

export const listPossibleStageTemplates = (stage_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/LIST_POSSIBLE_PLAN_STAGE_TEMPLATES',
    method: 'GET',
    endpoint: '/stages/' + stage_id + '/possible_plan_stage_templates',
  });
};

export const listPossiblePlanTemplateCells = (child_plan_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/LIST_POSSIBLE_TEMPLATE_CELLS',
    method: 'GET',
    endpoint: '/plans/working/' + child_plan_id + '/possible_template_cells',
  });
};

export const listPossiblePlanVersionSpecifications = (plan_version_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/LIST_PLAN_VERSION_SPECIFICATION_CODES',
    method: 'GET',
    endpoint:
      '/plans/versions/' + plan_version_id + '/possible_specification_codes',
  });
};

export const attachSpecificationToPlanVersion = (plan_version_id, formData) => {
  return store.dispatch({
    action: 'table.working_set_plans/ATTACH_SPECIFICATION_CODE_TO_PLAN_VERSION',
    method: 'POST',
    endpoint:
      '/plans/versions/' + plan_version_id + '/attach_specification_code',
    data: formData,
  });
};

export const listPinnedPlanVersionSpecifications = (plan_version_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/LIST_PINNED_PLAN_VERSION_SPECIFICATIONS',
    method: 'GET',
    endpoint: '/plans/versions/' + plan_version_id + '/pinned_specifications',
  });
};

export const searchPdfTextPositions = (plan_version_id, query) => {
  return store.dispatch({
    action: 'table.working_set_plans/SEARCH_TEXT_PLAN_VERSIONS',
    method: 'GET',
    endpoint: `/plans/versions/${plan_version_id}/search?q=${encodeURIComponent(
      query
    )}`,
  });
};

export const searchPlanVersionsTextOccurrences = (stage_id, query) => {
  return store.dispatch({
    action: 'table.working_set_plans/SEARCH_TEXT_OCCURRENCES_PLAN_VERSIONS',
    method: 'GET',
    endpoint: `/stages/${stage_id}/plans/search_occurrences?q=${encodeURIComponent(
      query
    )}&list=versions`,
  });
};

export const parsePlanPdfToJson = (plan_version_id) => {
  return store.dispatch({
    action: 'table.working_set_plans/PARSE_PLAN_PDF_TO_JSON',
    method: 'PUT',
    endpoint: '/plans/versions/' + plan_version_id + '/parse_pdf_to_json',
  });
};
